'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCampaign = exports.fetchCampaignGroups = exports.fetchCampaign = exports.fetchCampaigns = exports.c = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var c = exports.c = {
  ENDPOINT: 'api/v2/campaigns'
};

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var mappings = {
    charity: 'charity_ids'
  };

  var transforms = {
    charity: function charity(v) {
      return Array.isArray(v) ? v.join(',') : v;
    }
  };

  return (0, _client.get)(c.ENDPOINT, params, { mappings: mappings, transforms: transforms }).then(function (response) {
    return response.campaigns;
  });
};

var fetchCampaign = exports.fetchCampaign = function fetchCampaign() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if ((typeof id === 'undefined' ? 'undefined' : _typeof(id)) === 'object') {
    var _id$countryCode = id.countryCode,
        countryCode = _id$countryCode === undefined ? (0, _params.required)() : _id$countryCode,
        _id$slug = id.slug,
        slug = _id$slug === undefined ? (0, _params.required)() : _id$slug;


    return (0, _client.get)([c.ENDPOINT, countryCode, slug].join('/')).then(function (response) {
      return response.campaign;
    });
  }

  return (0, _client.get)(c.ENDPOINT + '/' + id).then(function (response) {
    return response.campaign;
  });
};

var fetchCampaignGroups = exports.fetchCampaignGroups = function fetchCampaignGroups() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.get)(c.ENDPOINT + '/' + id + '/groups').then(function (response) {
    return response.campaign_groups;
  });
};

var deserializeCampaign = exports.deserializeCampaign = function deserializeCampaign(campaign) {
  return {
    name: campaign.name,
    summary: campaign.description,
    id: campaign.id,
    uuid: campaign.uuid,
    slug: campaign.slug,
    url: campaign.url,
    target: null,
    raised: campaign.funds_raised.cents / 100,
    raisedOffline: null,
    totalDonations: null,
    getStartedUrl: campaign.get_started_url,
    donateUrl: campaign.donate_url
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/campaigns/everydayhero/index.js
// module id = 1401
// module chunks = 0